/**
 * Открывает окно выбора файлов с указанным типом
 * @param {String} contentType тип файла, например: 'image/*
 * @param {Boolean} multiple множественный выбор
 * @returns {Promise<File|File[]>}
 */
export default async function selectFile(contentType, multiple) {
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = multiple;
    input.accept = contentType;

    input.onchange = () => {
      const files = Array.from(input.files);
      if (multiple) {
        resolve(files);
      } else {
        resolve(files[0]);
      }
    };

    input.click();
  });
}
